<template>
  <v-tooltip
    bottom
    color="info"
    max-width="400px"
    min-width="400px"
    class="rounded-0"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-card
        id="CO2"
        elevation="0"
        class="pa-2 hidden-sm-and-down rounded-0 transparent"
        v-on="on"
        v-bind="attrs"
        style="cursor:help;text-align:center;"
        width="200px"
      >
        <b class="primary white--text">
          Du har sparet {{ CO2SavedInKg | formatDouble }} kg CO2
          <!-- siden {{ fromDate | formatDate }}-->
        </b>
      </v-card>
      <v-icon class="hidden-md-and-up" v-on="on" v-bind="attrs" color="white">
        {{ CO2Icon }}
      </v-icon>
    </template>
    <span>
      Du har sparet {{ CO2SavedInKg | formatDouble }} kg CO2 *<br />
      Siden {{ fromDate | formatDate }}<br />
      {{ distanceInKm.electric | formatDouble }} km med el-bil<br />
      {{ distanceInKm.regular | formatDouble }} km med almindelig bil<br />
      <i style="font-size:8pt">* Bemærk venligst at alle estimerede oplyste emissionstal alene gælder fakturerede kilometer og tager således ikke hensyn til: tilkørsel (før), frakørsel (efter), samkørsel (under) udførsel af en booking.<br />
      Emissionstal oplyses ej heller for kørsler udført på timepris, da der alene faktureres ud fra medgået tid uden angivelse af tilbagelagte kilometer.</i>
    </span>
  </v-tooltip>
</template>

<script>
import { tools } from "../helpers";
import { dictionary } from "../helpers";

export default {
  created() {
    let d = new Date();
    this.toDate = tools.splitDateTime(d).date;
    this.fromDate = tools.splitDateTime(
      new Date(d.getTime() - 7 * 60 * 60 * 24 * 1000)
    ).date; //7 days back from today

    this.updateCO2();
  },
  data: () => ({
    CO2Icon: dictionary.mdi.CO2,
    fromDate: null,
    toDate: null,
    CO2SavedInKg: 0,
    distanceInKm: {
      regular: 0,
      electric: 0
    }
  }),
  filters: {
    formatDate: function(date) {
      return tools.formatDate(date);
    },
    formatDouble: function(val) {
      return tools.parseDoubleToString(val);
    }
  },
  computed: {
    user: {
      get() {
        return this.$store.state.user.activeUser;
      }
    }
  },
  watch: {
    user() {
      this.updateCO2();
    }
  },
  methods: {
    async updateCO2() {
      if (
        this.$store.state.user.activeUser &&
        this.$store.state.authentication.status.loggedIn
      ) {
        let customerIds = [];

        if (this.$store.state.user.activeUser.accounts) {
          this.$store.state.user.activeUser.accounts.forEach(account => {
            customerIds.push(account.id);
          });
        }

        if (customerIds && customerIds.length) {
          const { fromDate, toDate } = this;
          const bookingId = -1;
          await this.$store
            .dispatch("booking/calculateCO2Footprint", {
              customerIds,
              fromDate,
              toDate,
              bookingId
            })
            .then(
              response => {
                if (response) {
                  response.forEach(co2Footprint => {
                    this.CO2SavedInKg += co2Footprint.co2_saved / 1000;
                    if (co2Footprint.electric) {
                      this.distanceInKm.electric +=
                        co2Footprint.distance / 1000;
                    } else {
                      this.distanceInKm.regular += co2Footprint.distance / 1000;
                    }
                  });
                }
              },
              error => {
                console.error(error);
              }
            );
        }
      }
    }
  }
};
</script>
